import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_user", res.data.username);
      toast.success("Logged in successfully.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: "#FDFCF8" }} data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <h1 className="font-heading text-3xl md:text-4xl tracking-tight text-center mb-2 text-foreground">Admin</h1>
        <p className="font-body text-sm text-muted-foreground text-center mb-10">Sign in to manage the website.</p>

        <form onSubmit={handleLogin} className="space-y-6" data-testid="admin-login-form">
          <div>
            <Label className="font-body text-sm text-foreground">Username</Label>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-2 bg-transparent border-0 border-b border-[hsl(48,12%,88%)] rounded-none px-0 py-3 font-body focus-visible:ring-0 focus-visible:border-[#5C6B5D]"
              placeholder="admin"
              data-testid="admin-username"
            />
          </div>
          <div>
            <Label className="font-body text-sm text-foreground">Password</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-transparent border-0 border-b border-[hsl(48,12%,88%)] rounded-none px-0 py-3 font-body focus-visible:ring-0 focus-visible:border-[#5C6B5D]"
              placeholder="Enter password"
              data-testid="admin-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full font-body text-sm tracking-[0.15em] uppercase px-8 py-3 bg-[#5C6B5D] text-white hover:bg-[#5C6B5D]/90 transition-all duration-300 disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="font-body text-xs text-muted-foreground/50 text-center mt-8">
          Bikram Jha — Content Management
        </p>
      </div>
    </div>
  );
}
